import { VariablesOf } from '@graphql-typed-document-node/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAccountsClient } from 'services/api';
import { CreateAddressDocument } from 'types/api/account.types';

import { accountAddressesQuery } from './queries';

export const useCreateAddress = () => {
  const accountClient = useAccountsClient();
  const queryClient = useQueryClient();

  const { isPending, isPaused, isError, mutate } = useMutation({
    mutationFn: (
      variables: VariablesOf<typeof CreateAddressDocument>['input'],
    ) => accountClient.request(CreateAddressDocument, { input: variables }),
    onSuccess: ({ createAddress }) => {
      queryClient.invalidateQueries({
        queryKey: accountAddressesQuery.queryKey,
      });
      queryClient.setQueryData(accountAddressesQuery.queryKey, (oldData) => {
        if (!!oldData) {
          return {
            addresses: [...oldData.addresses, createAddress],
          };
        }
      });
    },
  });

  return {
    createAddress: mutate,
    isLoading: isPending && !isPaused,
    isError,
  };
};
